// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_mm-0";
export var animationContainer = "_mm-1";
export var itemPrice = "_mm-a";
export var itemizedContent = "_mm-9";
export var itemizedHeader = "_mm-7";
export var itemizedRow = "_mm-8";
export var itemizedSection = "_mm-6";
export var modalContent = "_mm-2";
export var orderName = "_mm-3";
export var refundOption = "_mm-4";
export var refundOptionsContainer = "_mm-5";
export var shippingLabel = "_mm-b";
export var totalRow = "_mm-c";